module.exports = __webpack_public_path__ + "28f7d4ec8f43c85bdcb0e610696730f6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/broom-s.png
// module id = 1994
// module chunks = 0